import reactContainerFactory from '@/components/react-container/reactContainerFactory';
import { lazy } from 'react';
import { RouteConfig } from 'vue-router';

const simulation: RouteConfig = {
  path: '/simulation',
  name: 'simulation',
  meta: {
    title: 'Simulation',
    icon: 'Report Center',
  },
  redirect: '/simulation/experiments',
  component: () => import('@/views/layout/index.vue'),
  children: [
    {
      path: 'experiments',
      name: 'simulation.experiments',
      meta: {
        title: 'Experiments',
        filterSave: true,
      },
      component: reactContainerFactory({
        name: 'simulation.experiments',
      }),
      props: {
        component: () =>
          lazy(() => import('@/react-app/pages/simulation/experiments/index')),
      },
    },
    {
      path: 'experiments/create',
      name: 'simulation.experiments.create',
      meta: {
        title: 'Create Experiment',
        menuHide: true,
        navList: [
          { routeName: 'simulation', title: 'Simulation' },
          {
            routeName: 'simulation.experiments',
            title: 'Experiments',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'simulation.experiments.create',
      }),
      props: {
        component: () =>
          lazy(
            () => import('@/react-app/pages/simulation/experiments/edit/index')
          ),
      },
    },
    {
      path: 'experiments/edit/:experimentId',
      name: 'simulation.experiments.edit',
      meta: {
        title: 'Edit Experiment',
        menuHide: true,
        navList: [
          { routeName: 'simulation', title: 'Simulation' },
          {
            routeName: 'simulation.experiments',
            title: 'Experiments',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'simulation.experiments.edit',
      }),
      props: {
        component: () =>
          lazy(
            () => import('@/react-app/pages/simulation/experiments/edit/index')
          ),
      },
    },
    {
      path: 'experiments/view/:experimentId',
      name: 'simulation.experiments.view',
      meta: {
        title: 'View Experiment',
        menuHide: true,
        navList: [
          { routeName: 'simulation', title: 'Simulation' },
          {
            routeName: 'simulation.experiments',
            title: 'Experiments',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'simulation.experiments.view',
      }),
      props: {
        component: () =>
          lazy(
            () => import('@/react-app/pages/simulation/experiments/view/index')
          ),
      },
    },
    {
      path: 'globalConfig',
      name: 'simulation.globalconfig',
      meta: {
        title: 'Global Config',
        filterSave: true,
      },
      component: reactContainerFactory({
        name: 'simulation.globalconfig',
      }),
      props: {
        component: () =>
          lazy(
            () => import('@/react-app/pages/simulation/global-config/index')
          ),
      },
    },
    {
      path: 'globalConfig/create',
      name: 'simulation.globalconfig.create',
      meta: {
        title: 'Create Global Config',
        menuHide: true,
        navList: [
          { routeName: 'simulation', title: 'Simulation' },
          {
            routeName: 'simulation.globalconfig',
            title: 'Global Config',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'simulation.globalconfig.create',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import('@/react-app/pages/simulation/global-config/detail/index')
          ),
      },
    },
    {
      path: 'globalConfig/edit/:globalConfigId',
      name: 'simulation.globalconfig.edit',
      meta: {
        title: 'Edit Global Config',
        menuHide: true,
        navList: [
          { routeName: 'simulation', title: 'Simulation' },
          {
            routeName: 'simulation.globalconfig',
            title: 'Global Config',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'simulation.globalconfig.edit',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import('@/react-app/pages/simulation/global-config/detail/index')
          ),
      },
    },
  ],
};

export default simulation;
